bcn.navigation = (function () {

  'use strict';

  return {
    init: function () {
      $('.js-navigation-toggle').on('click', function () {
        $('.js-navigation-holder').toggleClass('js-active');
      });
    }
  };
})();
